// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1TCJm","rightAdornment":"Header_rightAdornment__1jwoC"};